// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pb-mng-dialog-bottom {
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
}

.pm-stage-text {
  white-space: nowrap;
}

.pm-view-icon {
  text-align: center;
}

.pm-info-icon {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/views/panel/ProbationManagement/ProbationManagement.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".pb-mng-dialog-bottom {\n  padding: 16px 24px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.pm-stage-text {\n  white-space: nowrap;\n}\n\n.pm-view-icon {\n  text-align: center;\n}\n\n.pm-info-icon {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
